// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "@keyframes adicionar-proposta-pulse {\n  0% {\n    box-shadow: 0 0 0 0 rgba(108, 117, 125, 0.55);\n  }\n  70% {\n    box-shadow: 0 0 0 10px rgba(108, 117, 125, 0);\n  }\n  100% {\n    box-shadow: 0 0 0 0 rgba(108, 117, 125, 0);\n  }\n}\n\n.btn-adicionar-proposta-pulse {\n  animation: adicionar-proposta-pulse 1.8s ease-out infinite;\n}\n\n.btn-adicionar-proposta-pulse:disabled {\n  animation: none;\n}\n", ""]);
// Exports
module.exports = exports;
